module.exports = __webpack_public_path__ + "img/icon2.09851992.svg";